import { Show, batch, createRenderEffect, createSignal, splitProps } from "solid-js";
import { createFormControl } from "solid-forms";
import { getFileString } from "../SHARED/helpers";

import { directives$ } from "../../directives";
//
import type { FormControlData } from "../SHARED/_model";
import type { ElementViewerProps, MainProps } from "./_model";

export default function InputFile<D extends FormControlData>(props: MainProps<D>) {
  const [local, others] = splitProps(props, [
    "control",
    "onChange",
    "update",
    "classes",
    "placeholder",
    "elements",
    "accept",
  ]);
  let input_ref: HTMLInputElement = undefined;
  // @ts-ignore: unused function 'dragNDrop'
  const { dragNDrop } = directives$.events;
  const _control = Array.isArray(local.control) ? createFormControl<FileList, D>(...local.control) : local.control;
  const [$viewer_data, set_viewer_data] = createSignal({
    placeholder: typeof _control.value === "string" ? _control.value : local.placeholder,
  } as ElementViewerProps);
  const [dragging, setDragging] = createSignal(false);
  function onInputClicked() {
    input_ref?.click();
  }
  function onSelectFiles(files: FileList) {
    let in_progress_files = 0;
    let ready_files = 0;
    const buffers = [];
    for (const file of files) {
      in_progress_files++;
      getFileString(file, (buffer) => {
        buffers.push(buffer);
        ready_files++;
        if (ready_files === in_progress_files) {
          batch(() => {
            set_viewer_data({ files, buffers, placeholder: buffers[0], file: files[0] });
            local.onChange?.(files);
          });
        }
      });
    }
  }

  function setValue(files: FileList) {
    batch(() => {
      //! KEEP SETTING TO UNDEFINED FIRST BEFORE SETTING ACTUAL VALUE TO AVOID UN-UPDATED VALUE
      _control.setValue(undefined);
      _control.setValue(files);
    });
  }
  createRenderEffect(() => {
    const value = _control.value;
    // console.log("input file :: ", " :: ", unwrap(value));
    if (value == undefined) {
      if ($viewer_data()?.files) {
        set_viewer_data((s) => ({ files: null, file: null, buffers: null, placeholder: local.placeholder }));
      }
    } else if (typeof value === "string") {
      // incase just updating value with a string maybe via api fetch
      set_viewer_data((s) => ({ ...s, placeholder: value }));
      _control.setValue(undefined);
    } else {
      // checking actual files value
      onSelectFiles(value);
    }
  });
  return (
    <div
      use:dragNDrop={{
        onEnter: () => setDragging(true),
        onLeave: () => setDragging(false),
        onDrop: (e) => setValue(e.dataTransfer.files),
      }}
      class={"relative flex overflow-hidden group" + " " + (others.class ?? "") + " " + "container"}
      classList={{
        // invalid: !!_control.errors,
        touched: _control.isTouched,
        disabled: _control.isDisabled,
        required: _control.isRequired,
      }}
    >
      {/* TODO: add props to input */}
      <input
        {...others}
        ref={input_ref}
        type="file"
        class="!hidden"
        onChange={(e) => setValue(e.target.files)}
        onblur={() => _control.markTouched(true)}
        onfocus={() => _control.markTouched(true)}
        onfocusin={() => _control.markTouched(true)}
        onfocusout={() => _control.markTouched(false)}
        disabled={_control.isDisabled}
        required={_control.isRequired}
        accept={local.accept ?? "*"}
      />
      {local.elements?.viewer && local.elements?.viewer?.($viewer_data())}
      <Show
        when={local.elements?.overlay == undefined}
        fallback={local.elements?.overlay?.({
          onclick: onInputClicked,
          ref: input_ref,
          drag: dragging(),
          viewer_data: $viewer_data(),
          class:
            "absolute top-0 left-0 min-w-full min-h-full w-full h-full !z-10 invisible group-hover:!visible cursor-pointer",
        })}
      >
        <span
          onclick={local.elements?.overlay == undefined ? undefined : onInputClicked}
          // onclick={onInputClicked}
          class={
            "absolute top-0 flex min-w-full min-h-full w-full h-full !z-10  items-center justify-center text-center" +
            " " +
            (local.elements?.viewer == undefined ? "invisible group-hover:!visible" : "") +
            " " +
            (dragging() ? "!visible" : "") +
            " " +
            (local.elements?.overlay != undefined ? "cursor-pointer" : "") +
            " " +
            (local.classes?.overlay ?? "") +
            " " +
            "overlay"
          }
        >
          <Show when={$viewer_data()?.buffers == undefined} fallback={$viewer_data().file.name}>
            {!dragging() ? "choose file" : "drop files here"}
          </Show>
        </span>
      </Show>
    </div>
  );
}
